// イラストレーターの紹介欄の下書きを ?credit=preview のときだけ見せる（名前が入るまで本番では出さない）
if (new URLSearchParams(location.search).get('credit') === 'preview') for (const el of document.querySelectorAll('[data-credit-draft]')) el.hidden = false;
